<div
  class="image-display-container"
  [ngClass]="[alignmentClass(), displayClass()]"
  [style.width.px]="containerWidthPx()"
  [style.height.px]="containerHeightPx()">

  @if (hasImage()) {
    <img
      class="display-image"
      [src]="base64Image()"
      [alt]="altText()"
      [style.width.px]="imageRenderWidthPx()"
      [style.height.px]="imageRenderHeightPx()"
      [class.loading]="!imageLoaded()"
      (load)="onImageLoad($event)"
      (error)="onImageError()"
      (loadstart)="onImageLoadStart()"
    />
  }
  @else if (shouldShowPlaceholder()) {
    <div class="image-placeholder">
      <div class="placeholder-content">
        <i class="fa fa-image placeholder-icon"></i>
        <span class="placeholder-text">{{ placeholderText() }}</span>
      </div>
    </div>
  }

  @if (!imageLoaded() && hasImage()) {
    <div class="loading-overlay">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
  }

  @if (imageError()) {
    <div class="error-overlay">
      <i class="fa fa-exclamation-triangle"></i>
      <span>Failed to load image</span>
    </div>
  }
</div>
